import React from 'react'

export default function LinkedinIcon (props) {
  return (
    <svg x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16'>
      <g>
        <rect data-color='color-2' x='7' fill='currentColor' width='2' height='2' />
        <rect x='11.9' y='2.1' transform='matrix(0.7069 0.7074 -0.7074 0.7069 5.9537 -8.2658)' fill='currentColor' width='2' height='2' />
        <rect x='14' y='7' fill='currentColor' width='2' height='2' />
        <rect x='11.9' y='11.9' transform='matrix(-0.7074 -0.7069 0.7069 -0.7074 12.956 31.2634)' fill='currentColor' width='2' height='2' />
        <rect x='7' y='14' fill='currentColor' width='2' height='2' />
        <rect x='2.1' y='11.9' transform='matrix(-0.7069 -0.7074 0.7074 -0.7069 -3.9536 24.261)' fill='currentColor' width='2' height='2' />
        <rect y='7' fill='currentColor' width='2' height='2' />
        <rect x='2.1' y='2.1' transform='matrix(0.7074 0.7069 -0.7069 0.7074 3.0488 -1.2635)' fill='currentColor' width='2' height='2' />
        <path fill='currentColor' d='M8,4C5.8,4,4,5.8,4,8s1.8,4,4,4s4-1.8,4-4S10.2,4,8,4z' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/sun.js